import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  loadMessageTemplateById,
  selectTemplatesTenantLogo,
  selectTemplatesTenantSender,
} from '../store/templatesSlice';
import { buildPreviewTemplate } from '../lib/buildPreviewTemplate';

export function useTemplatePreview() {
  const dispatch = useDispatch();
  const tenantLogoUrl = useSelector(selectTemplatesTenantLogo);
  const tenantSender = useSelector(selectTemplatesTenantSender);
  const [previewTemplate, setPreviewTemplate] = useState(null);

  const openPreview = useCallback(
    async (template) => {
      const fullTemplate = await dispatch(
        loadMessageTemplateById({ templateId: template.id }),
      ).unwrap();
      setPreviewTemplate(buildPreviewTemplate(fullTemplate, tenantLogoUrl, tenantSender));
    },
    [dispatch, tenantLogoUrl, tenantSender],
  );

  const closePreview = useCallback(() => setPreviewTemplate(null), []);

  return { previewTemplate, openPreview, closePreview };
}
